import axios from 'axios';
import StorageService from '../services/StorageService';

// const user = StorageService.getSession('user_info');
// const comp = StorageService.getSession('selected_org');
const url = process.env.REACT_APP_UNITY_API2_URL;

export function getProfile() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
  };
  axios
    .post(`${url}:3000/v1/user/profile`, data)
    .then(res => {
      this.setState({ roleList: res.data.data });
    })
    .catch(error => {
      console.log(error);
    });
}

export function getProfile_v2() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
  };
  return axios.post(`${url}:3000/v1/user/profile`, data);
}

export function getUser() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
    company_id: comp.CompanyID,
  };
  axios
    .post(`${url}:3000/v1/users`, data)
    .then(res => {
      this.setState({ userList: res.data.data });
    })
    .catch(error => {
      console.log(error);
    });
}

export function getUser_v2() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
    company_id: comp.CompanyID,
  };
  return axios.post(`${url}:3000/v1/users`, data);
}

export function getStore() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
    company_id: comp.CompanyID,
  };
  axios
    .post(`${url}:3001/v1/store`, data)
    .then(res => {
      this.setState({ storeList: res.data.data });
    })
    .catch(error => {
      console.log(error);
    });
}

export function getTax() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
    company_id: comp.CompanyID,
  };
  axios
    .post(`${url}:3001/v1/tax`, data)
    .then(res => {
      this.setState({ taxList: res.data.data });
    })
    .catch(error => {
      console.log(error);
    });
}

export function getTax_v2() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
    company_id: comp.CompanyID,
  };
  return axios.post(`${url}:3001/v1/tax`, data);
}

export function getPayment() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
    company_id: comp.CompanyID,
  };
  axios
    .post(`${url}:3001/v1/payment`, data)
    .then(res => {
      this.setState({ paymentList: res.data.data });
    })
    .catch(error => {
      console.log(error);
    });
}

export function getPayment_v2() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
    company_id: comp.CompanyID,
  };
  return axios.post(`${url}:3001/v1/payment`, data);
}

export function getProductList() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
    company_id: comp.CompanyID,
  };
  axios
    .post(`${url}:3002/v1/product`, data)
    .then(res => {
      //console.log(res.data.data);
      this.setState({ productList: res.data.data });
    })
    .catch(error => {
      console.log(error);
    });
}

export function getProductCategory() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
    company_id: comp.CompanyID,
  };
  axios
    .post(`${url}:3002/v1/product/category`, data)
    .then(res => {
      //console.log(res.data.data);
      this.setState({ categoryList: res.data.data });
      // console.log(res.data);
      // return res.data.data;
    })
    .catch(error => {
      console.log(error);
    });
}

export function getProductCategory_v2() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
    company_id: comp.CompanyID,
  };
  return axios.post(`${url}:3002/v1/product/category`, data);
}

export function getProductType() {
  const user = StorageService.getSession('user_info');
  const comp = StorageService.getSession('selected_org');
  const data = {
    //session_key: user.session_key,
    session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
    company_id: comp.CompanyID,
  };
  axios
    .post(`${url}:3002/v1/product/type`, data)
    .then(res => {
      this.setState({ typeList: res.data.data });
      // console.log(res.data);
      // return res.data.data;
    })
    .catch(error => {
      console.log(error);
    });
}
